<div class="form-item">
    @if (folders) {
        <mat-form-field class="searchable-list-container">
            <mat-label>Dossier</mat-label>
            <mat-select
                msInfiniteScroll
                placeholder="Dossier"
                panelClass="searchable-list"
                matTooltip="Sélection d’un dossier"
                (selectionChange)="onSelected($event.value)"
                (infiniteScroll)="onScroll()">
                @if (searchResult) {
                    <mat-select-trigger>
                        <div class="item">
                            <div class="name">{{ searchResult.name }}</div>
                        </div>
                    </mat-select-trigger>
                }
                <div class="search-zone">
                    <fa-icon matPrefix class="search-icon" [icon]="faMagnifyingGlass"></fa-icon>
                    <form [formGroup]="folderSearchForm">
                        <input class="search-input" formControlName="folderSearch" matInput placeholder="recherche" (keydown)="$event.stopPropagation()" />
                    </form>
                    <button mat-icon-button class="primary-button" (click)="onReset()"><fa-icon [icon]="faXmark"></fa-icon></button>
                </div>
                <mat-option [disabled]="true">
                    <div class="searchable-list-item searchable-list-header-item">
                        <div class="item-name">Nom</div>
                        <div class="item-date">Date</div>
                        <div class="item-state">État</div>
                        <div class="item-customer">Client</div>
                        <!-- <div class="item-box">Bannette</div> -->
                    </div>
                </mat-option>
                @for (folder of folders; track folder.id) {
                    <mat-option [value]="folder">
                        <div class="searchable-list-item searchable-list-data-item">
                            <div class="item-name">{{ folder.name }}</div>
                            <div class="item-date">{{ folder.creationDate | date: FRENCH_DATETIME_FORMAT }}</div>
                            <div class="item-state">{{ folder['state'] }}</div>
                            <div class="item-customer">{{ folder['customerName'] }}</div>
                            <!-- <div class="item-box">{{folder['box']}}</div> -->
                        </div>
                    </mat-option>
                }
                <ngx-spinner name="select-folder-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
            </mat-select>
        </mat-form-field>
    }
</div>
